export default "__VITE_ASSET__e6c590b1__"